import { render, staticRenderFns } from "./ViewModeNormal.vue?vue&type=template&id=563a16a1&scoped=true"
import script from "./ViewModeNormal.vue?vue&type=script&lang=js"
export * from "./ViewModeNormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a16a1",
  null
  
)

export default component.exports